module.exports = __webpack_public_path__ + "img/flex-align-left.87561c63.svg";